module.exports = __webpack_public_path__ + "media/images/input-spinner-481590a96990e9a117cc1414a286def3.svg";